"use client";
import React, { useState, useMemo } from "react";
import HeroPage from "./components/HeroPage";
import { SliderParent } from "./components/OurServices";
import { MemberType } from "../../../../types";
import { useFetchValidSocialMediaLinks } from "src/app/lib/useFetcchValidSocialMediaLinks";
import CardGrid from "../../CardGrid";
import { useFetchCompanyInfo } from "src/app/lib/fetchCompanyInfo";
import ContactForm from "./components/ContactUsForm";
// import { socialMediaLinks } from "./AnnouncementPostPage";
import Link from "next/link";
import { useCompanyStaff } from "src/app/lib/useCompanyStaff";
import CustomSelect from "./components/ui/form/CustomSelect";
import Skeleton from "react-loading-skeleton";
import Image from "next/image";
import { generateSlugWithId } from "src/app/serverUtils";
import { VerifiedBadge } from "../../Icon";
import { useDirectors } from "src/app/lib/useCompanyDirector";

const Contact1 = () => {
  const { data: staffData, isLoading: staffLoading } = useCompanyStaff();
  const { data: directorsData, isLoading: directorsLoading } = useDirectors();
  console.log({ directorsData });
  const data = staffData;
  const isLoading = staffLoading || directorsLoading;
  const options = useMemo(() => {
    const branches = data?.staff?.map((item) => item.branch);
    const uniqueBranches = new Set(branches);
    return Array.from([...uniqueBranches, "Directors"]).map((branch) => ({
      label: branch as string,
      value: branch as string,
    }));
  }, [data]); // Only recompute when `data` changes

  const [selectedValue, setSelectedValue] = useState<string | null>(
    "Directors"
  );
  const members = useMemo(() => {
    if (selectedValue === "Directors") {
      return directorsData || [];
    }
    return data?.staff?.filter((item) => {
      if (selectedValue && selectedValue !== "All branches") {
        return item.branch === selectedValue;
      }
      return item;
    });
  }, [selectedValue, data?.staff, directorsData]);
  // Efficient handler for select change
  const handleSelect = (value: string) => {
    setSelectedValue(value); // Updating state
    console.log("Selected branch:", value); // Keeping the log for debugging
  };
  const { data: item } = useFetchCompanyInfo();
  const { socialMediaLinks, loading } = useFetchValidSocialMediaLinks();

  return (
    <section className="overflow-clip max-w-full pb-24">
      <HeroPage
        subHeader="Explore our range of professional real estate services designed to meet your every need."
        header="Contacts & Services"
      />
      <div className="wrapper py-4">
        <div className="grid-container">
          <div className="item flex flex-col gap-10">
            <div className="first">
              <h3 className="text-primary !mb-4 !text-left">Contact Form</h3>
              <CardParent>
                <ContactForm email={item?.companyInfo?.email as string} />
              </CardParent>
            </div>
            <CardParent>
              <div className="text-secondary-main text-xl block font-semibold border-b border-b-disabled-main pb-3 mb-4">
                Head Office
              </div>
              {loading ? (
                <Skeleton
                  height={20}
                  count={3}
                  className="w-full my-1  max-w-[600px]"
                />
              ) : (
                <>
                  <div className="items flex flex-col gap-4">
                    {Array.isArray(item?.companyInfo?.phone_number) ? (
                      <div className="items flex gap-3">
                        <span className="min-w-[24px] aspect-square">
                          <CallIconVariant />
                        </span>
                        <div className="contacts flex-wrap flex gap-6">
                          {Array.isArray(item?.companyInfo?.phone_number) &&
                          item.companyInfo.phone_number.length > 0 ? (
                            item.companyInfo.phone_number.map(
                              (phone, index) => (
                                <span
                                  className="text-secondary-main"
                                  key={index}
                                >
                                  <Link
                                    className="hover:underline whitespace-nowrap"
                                    href={`tel:${phone}`}
                                  >
                                    {phone}
                                  </Link>
                                </span>
                              )
                            )
                          ) : (
                            <p className="text-gray-500">
                              No phone numbers available
                            </p>
                          )}
                        </div>
                      </div>
                    ) : null}

                    {/* {loading && <div>Loading</div>} */}
                    <div className="items mt-2 text-secondary-main flex gap-3">
                      <EmailIconVariant />
                      {loading ? (
                        <Skeleton height={30} className="w-full" />
                      ) : item?.companyInfo?.email ? (
                        <Link
                          className="hover:underline"
                          href={`mailto:${item?.companyInfo?.email}`}
                        >
                          {item?.companyInfo?.email}
                        </Link>
                      ) : (
                        <p className="">No email available</p>
                      )}
                    </div>

                    <div className="items mt-2 text-secondary-main flex gap-3">
                      <LocationVariant />

                      {loading ? (
                        <Skeleton
                          height={30}
                          count={3}
                          className="w-full max-w-[300px]"
                        />
                      ) : item?.companyInfo?.email ? (
                        <span>
                          <Link
                            href={`https://www.google.com/maps/search/?q=${encodeURIComponent(
                              item?.companyInfo?.head_office_address || ""
                            )}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="hover:underline"
                          >
                            {item?.companyInfo?.head_office_address}
                          </Link>
                        </span>
                      ) : (
                        <p>No email available</p>
                      )}
                    </div>
                  </div>

                  <div className="icons flex gap-6 items-center mt-10">
                    {socialMediaLinks?.map((item, index) => {
                      return (
                        <Link href={item.url} key={index}>
                          {item.icon}
                        </Link>
                      );
                    })}
                  </div>
                </>
              )}
            </CardParent>
          </div>
          <CardParent
            className=" sticky top-[75px] !h-max !px-2"
            noPadding={true}
          >
            <div className="first bg-white items-center top-0 flex justify-between p-4">
              <h3 className="h5">
                {selectedValue === "Directors"
                  ? "Company Directors"
                  : "Company Staff"}
              </h3>
              {!isLoading && !data?.staff.length ? null : (
                <div className="select h-max px-2 p-2 border rounded-md border-themeColor">
                  <CustomSelect
                    options={options}
                    value={selectedValue}
                    onChange={setSelectedValue}
                    handleSelect={handleSelect}
                    placeholder="All branches"
                  />
                </div>
              )}
            </div>
            {/* Parent container with scroll */}
            <div className="parent  max-h-[500px] scrollbar-hide overflow-y-auto w-full">
              {/* Header */}
              {/* Scrollable content */}
              <div className="">
                {isLoading ? (
                  <Skeleton count={8} height={120} className="w-full" />
                ) : members && members.length > 0 ? (
                  <CardGrid maxColumns={1}>
                    {members.map((item, index) => (
                      <ContactCard key={index} {...item} />
                    ))}
                  </CardGrid>
                ) : (
                  <div>
                    No staff information attached yet. Please try again later.
                  </div>
                )}
              </div>
            </div>
          </CardParent>
        </div>
        {item?.companyServices &&
        item?.companyServices[0] !== null &&
        item?.companyServices[0] !== "N/A" ? (
          <div className="carousel mt-12">
            <h3 className="mb-4 text-primary">Services</h3>
            {item?.companyServices && item?.companyServices.length > 0 ? (
              <div className="">
                <SliderParent variant data={item?.companyServices} />
              </div>
            ) : (
              <div>No services available</div>
            )}
          </div>
        ) : null}
      </div>
    </section>
  );
};
export default Contact1;

const ContactCard: React.FC<MemberType> = ({
  name,
  id,
  email,
  phone,
  image,
  role,
  is_verified,
}) => {
  const slug = generateSlugWithId(id, name);
  return (
    <div
      style={{
        boxShadow: "0px 2px 10px 0px rgba(33, 33, 33, 0.05)",
      }}
      className="flex mx-4 rounded-xl py-4 pl-4 gap-4"
    >
      <Image
        height={100}
        width={100}
        className="rounded-full object-cover bg-[rgba(var(--primary-color-rgb),0.2)] h-[6rem] aspect-square shadow-lg"
        src={image || "/images/person-1.webp"}
        alt=""
      />
      <div className="items w-full text-secondary-main">
        <div className="first w-full border-b border-b-themeColor pb-4">
          <Link
            href={`/staff/${slug}`}
            className="text-themeColor hover:underline block text-base mb-2 font-medium"
          >
            <span className="flex items-center max-w-[180px] xlg:max-w-[160px] gap-2">
              <span className="truncate overflow-hidden whitespace-nowrap max-w-[180px] xlg:max-w-[140px]">
                {name}
              </span>{" "}
              <VerifiedBadge verified={is_verified as boolean} />
            </span>
          </Link>
          <h6 className="text-secondary-main font-medium capitalize">{role}</h6>
        </div>

        <div className="second text-sm flex pt-3 flex-col">
          {phone ? (
            <span className="flex items-center gap-1">
              <CallIcon />
              <Link
                className="hover:underline"
                href={`tel:${phone || "No phone number available"}`}
              >
                {phone}
              </Link>
            </span>
          ) : null}

          <span className="flex items-center gap-1">
            <EmailIcon />
            <Link
              className="hover:underline max-w-[250px] xlg:max-w-[180px] truncate overflow-hidden md:!max-w-[150px]"
              href={`mailto:${email}`}
            >
              {email}
            </Link>
          </span>
        </div>
      </div>
    </div>
  );
};

export const CardParent: React.FC<{
  children: React.ReactNode;
  className?: string;
  noPadding?: boolean;
}> = ({ children, className, noPadding }) => {
  return (
    <div
      style={{
        boxShadow: "0px 2px 10px 0px rgba(33, 33, 33, 0.05)",
      }}
      className={` p-8  ${
        noPadding && "!pb-0"
      }  rounded-xl bg-white ${className}`}
    >
      {children}
    </div>
  );
};

export const CallIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1659_9043)">
        <path
          d="M9.49805 3C10.339 3.22145 11.1061 3.66214 11.721 4.27705C12.3359 4.89196 12.7766 5.65906 12.998 6.5"
          fill="#2F364B"
        />
        <path
          d="M9.49805 3C10.339 3.22145 11.1061 3.66214 11.721 4.27705C12.3359 4.89196 12.7766 5.65906 12.998 6.5"
          stroke="#2F364B"
          stroke-width="0.771277"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M8.99805 5C10.0305 5.27625 10.7218 5.9675 10.998 7L8.99805 5Z"
          fill="#2F364B"
        />
        <path
          d="M8.99805 5C10.0305 5.27625 10.7218 5.9675 10.998 7"
          stroke="#2F364B"
          stroke-width="0.771277"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M9.77438 9.58361C9.84362 9.53754 9.92326 9.50946 10.0061 9.50193C10.0889 9.4944 10.1723 9.50765 10.2487 9.54049L13.1962 10.8611C13.2956 10.9036 13.3785 10.9771 13.4326 11.0706C13.4867 11.1641 13.509 11.2726 13.4963 11.3799C13.3991 12.1055 13.0418 12.7712 12.4907 13.2531C11.9395 13.7351 11.2321 14.0004 10.5 13.9999C8.24566 13.9999 6.08365 13.1043 4.48959 11.5103C2.89553 9.91621 2 7.7542 2 5.49986C1.99944 4.76774 2.2648 4.06033 2.74673 3.5092C3.22865 2.95806 3.89435 2.60072 4.62 2.50361C4.72727 2.49087 4.83578 2.51321 4.9293 2.56729C5.02281 2.62137 5.0963 2.70428 5.13875 2.80361L6.45938 5.75361C6.49182 5.82938 6.50504 5.912 6.49784 5.99411C6.49064 6.07621 6.46326 6.15527 6.41813 6.22424L5.0825 7.81236C5.03512 7.88385 5.00711 7.96641 5.00119 8.05197C4.99528 8.13753 5.01166 8.22316 5.04875 8.30049C5.56563 9.35861 6.65938 10.4392 7.72063 10.9511C7.79836 10.988 7.88439 11.0041 7.9702 10.9976C8.05602 10.9911 8.13867 10.9624 8.21 10.9142L9.77438 9.58361Z"
          fill="#2F364B"
          stroke="white"
          stroke-width="0.771277"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1659_9043">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const EmailIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="16" height="16" rx="3.08511" fill="#2F364B" />
      <g clipPath="url(#clip0_1659_9050)">
        <path
          d="M4.11271 4.11316H11.3113C11.8062 4.11316 12.2111 4.51808 12.2111 5.01298V10.4119C12.2111 10.9068 11.8062 11.3117 11.3113 11.3117H4.11271C3.61781 11.3117 3.21289 10.9068 3.21289 10.4119V5.01298C3.21289 4.51808 3.61781 4.11316 4.11271 4.11316Z"
          stroke="white"
          stroke-width="0.804802"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12.2111 5.01355L7.712 8.16293L3.21289 5.01355"
          stroke="white"
          stroke-width="0.804802"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1659_9050">
          <rect
            width="10.7979"
            height="10.7979"
            fill="white"
            transform="translate(2.31445 2.31433)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const CallIconVariant = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M16.553 22.1335C15.113 22.0805 11.032 21.5165 6.75798 17.2435C2.48498 12.9695 1.92198 8.88946 1.86798 7.44846C1.78798 5.25246 3.46998 3.11946 5.41298 2.28646C5.64695 2.18543 5.90318 2.14696 6.15651 2.17484C6.40984 2.20271 6.65157 2.29597 6.85798 2.44546C8.45798 3.61146 9.56198 5.37546 10.51 6.76246C10.7186 7.06719 10.8077 7.43801 10.7605 7.80426C10.7133 8.17051 10.533 8.50659 10.254 8.74846L8.30298 10.1975C8.20872 10.2655 8.14237 10.3655 8.11625 10.4788C8.09014 10.5921 8.10603 10.711 8.16098 10.8135C8.60298 11.6165 9.38898 12.8125 10.289 13.7125C11.189 14.6125 12.442 15.4505 13.301 15.9425C13.4087 16.0029 13.5355 16.0198 13.6552 15.9897C13.775 15.9596 13.8787 15.8847 13.945 15.7805L15.215 13.8475C15.4485 13.5373 15.7929 13.3295 16.1762 13.2676C16.5594 13.2058 16.9517 13.2946 17.271 13.5155C18.678 14.4895 20.32 15.5745 21.522 17.1135C21.6836 17.3214 21.7864 17.5689 21.8197 17.8301C21.8529 18.0913 21.8154 18.3567 21.711 18.5985C20.874 20.5515 18.756 22.2145 16.553 22.1335Z"
        fill="var(--primary-color)"
      />
    </svg>
  );
};

export const EmailIconVariant = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.875 3.75H4.125C3.42904 3.75074 2.76179 4.02755 2.26967 4.51967C1.77755 5.01179 1.50074 5.67904 1.5 6.375V17.625C1.50074 18.321 1.77755 18.9882 2.26967 19.4803C2.76179 19.9725 3.42904 20.2493 4.125 20.25H19.875C20.571 20.2493 21.2382 19.9725 21.7303 19.4803C22.2225 18.9882 22.4993 18.321 22.5 17.625V6.375C22.4993 5.67904 22.2225 5.01179 21.7303 4.51967C21.2382 4.02755 20.571 3.75074 19.875 3.75ZM19.2103 8.09203L12.4603 13.342C12.3287 13.4444 12.1667 13.4999 12 13.4999C11.8333 13.4999 11.6713 13.4444 11.5397 13.342L4.78969 8.09203C4.71038 8.03214 4.64377 7.95709 4.59372 7.87123C4.54367 7.78537 4.51118 7.69042 4.49815 7.5919C4.48511 7.49338 4.49179 7.39325 4.51778 7.29733C4.54378 7.20142 4.58858 7.11162 4.64958 7.03316C4.71058 6.95471 4.78656 6.88916 4.87312 6.84032C4.95967 6.79149 5.05506 6.76034 5.15376 6.74869C5.25245 6.73704 5.35248 6.74513 5.44802 6.77247C5.54357 6.79981 5.63272 6.84587 5.71031 6.90797L12 11.7998L18.2897 6.90797C18.447 6.7892 18.6447 6.73711 18.84 6.76296C19.0354 6.78881 19.2128 6.89053 19.3338 7.04612C19.4547 7.20171 19.5096 7.39866 19.4865 7.59439C19.4634 7.79011 19.3642 7.96888 19.2103 8.09203Z"
        fill="var(--primary-color)"
      />
    </svg>
  );
};

export const LocationVariant = () => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 10.5C12.8284 10.5 13.5 9.82843 13.5 9C13.5 8.17157 12.8284 7.5 12 7.5C11.1716 7.5 10.5 8.17157 10.5 9C10.5 9.82843 11.1716 10.5 12 10.5Z"
        fill="var(--primary-color)"
      />
      <path
        d="M12 1.5C7.86469 1.5 4.5 4.71797 4.5 8.67188C4.5 10.5548 5.35828 13.0589 7.05094 16.1147C8.41031 18.5681 9.98297 20.7867 10.8009 21.8906C10.9392 22.0792 11.1199 22.2326 11.3284 22.3384C11.537 22.4441 11.7676 22.4992 12.0014 22.4992C12.2352 22.4992 12.4658 22.4441 12.6744 22.3384C12.8829 22.2326 13.0637 22.0792 13.2019 21.8906C14.0184 20.7867 15.5925 18.5681 16.9519 16.1147C18.6417 13.0598 19.5 10.5558 19.5 8.67188C19.5 4.71797 16.1353 1.5 12 1.5ZM12 12C11.4067 12 10.8266 11.8241 10.3333 11.4944C9.83994 11.1648 9.45542 10.6962 9.22836 10.1481C9.0013 9.59987 8.94189 8.99667 9.05764 8.41473C9.1734 7.83279 9.45912 7.29824 9.87868 6.87868C10.2982 6.45912 10.8328 6.1734 11.4147 6.05764C11.9967 5.94189 12.5999 6.0013 13.1481 6.22836C13.6962 6.45542 14.1648 6.83994 14.4944 7.33329C14.8241 7.82664 15 8.40666 15 9C14.9991 9.79538 14.6828 10.5579 14.1204 11.1204C13.5579 11.6828 12.7954 11.9991 12 12Z"
        fill="var(--primary-color)"
      />
    </svg>
  );
};
